import React from "react";
import  AiChat  from "../../../../../../components/AiChat";
import { GELABS_findings } from "./customComps/GELABS_findings";
import { AnnoExplorerRendererInCollectionPage } from "./customComps/AnnoExplorerRendererInCollectionPage";


export const CustomCompRenderer = ({
  configs,
  content,
  tabsPanelHeight,
  actionBarHeight
}) => {

  if(!configs?.comp) return null

  const comps = {
    AiChat,
    GELABS_findings,
    AnnoExplorerRendererInCollectionPage
  }
  const CompToRender = comps[configs.comp];

  return CompToRender
    ? <CompToRender {...{content, tabsPanelHeight, actionBarHeight, ...(configs.props || {})}}/> 
    : null;
 
};
